import { usePageTitleStore } from "entities/pageTitle";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { WeatherDayTitle } from "./weatherDayTitle/WeatherDayTitle";
import {
  WeatherDayContainer,
  WeatherDayWrapper,
  WeatherTextNull,
} from "./style";
import { WeatherRangeSwitcher } from "./weatherRangeSwitcher/WeatherRangeSwitcher";
import { useWeatherStore } from "entities/weather";
import { useBreadcrumbsStore } from "entities/breadcrumbs";
import { DayDetails } from "./dayDetails/DayDetails";

export const WeatherDay = () => {
  const { date } = useParams<{ date: string }>();

  const setTitle = usePageTitleStore((s) => s.setRouteTitle);
  const setBreadcrumbs = useBreadcrumbsStore((s) => s.setCrumbs);
  const scheduleRows = useWeatherStore((s) => s.scheduleRows);

  const currentDay = scheduleRows.find((day) => day.dateIso === date);

  useEffect(() => {
    if (!date) return;
    setTitle(<WeatherDayTitle date={currentDay?.titleShort} />);
    setBreadcrumbs([
      { title: "Моя пасека", url: "/", route: { path: "/" } },
      {
        title: "Погода на пасеке",
        url: "/weather",
        route: { path: "/weather" },
      },
    ]);

    return () => {
      setTitle("Погода на пасеке");
    };
  }, [setTitle, date]);

  if (!date || !currentDay) {
    return (
      <WeatherTextNull>
        Данные о погоде за этот день отсутствуют.
      </WeatherTextNull>
    );
  }

  return (
    <WeatherDayContainer>
      <WeatherDayWrapper>
        <WeatherRangeSwitcher activeDayIso={date} days={scheduleRows} />
        <DayDetails day={currentDay} />
      </WeatherDayWrapper>
    </WeatherDayContainer>
  );
};
